import React from 'react';

import {Alert} from '@ui';

export const IpBlacklistingIndexInfoMessage = () => {
    // TODO: Proper MUI icon should be added
    return (
        <Alert severity='info'>
            This blacklist is for disallowing stream URL generation in the Client APIs for some IP addresses.
            The end-users behind these IP addresses will not be able to stream any content booked by clients.
            <br/>
            This feature is not for blacklisting the IP addresses of the client servers which need to access the
            Client APIs!
        </Alert>
    );
};
